import { useState } from 'react'
import { avatarUrl } from '@/lib/utils/avatar'
import { cn } from '@/lib/utils/cn'

interface AvatarProps {
  src: string | null | undefined
  /** Iniciais exibidas sem foto ou quando a imagem falha. */
  fallback: string
  className?: string
  imgTestId?: string
}

/** Foto do usuário com fallback para iniciais (sem foto, URL inválida ou erro de carga). */
export function Avatar({ src, fallback, className, imgTestId }: AvatarProps) {
  const url = avatarUrl(src)
  const [failedUrl, setFailedUrl] = useState<string | null>(null)
  const showImage = url !== null && failedUrl !== url

  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-full text-xs font-semibold',
        className,
      )}
      aria-hidden
    >
      {showImage ? (
        <img
          src={url}
          alt=""
          referrerPolicy="no-referrer"
          loading="lazy"
          data-testid={imgTestId}
          className="h-full w-full object-cover"
          onError={() => setFailedUrl(url)}
        />
      ) : (
        fallback
      )}
    </span>
  )
}
